export const CUSTOMER_TAG_COLOR_PRESETS = [
  { color: '#04634E', label: '墨绿色' },
  { color: '#34BA9E', label: '品牌青绿' },
  { color: '#1677FF', label: '天蓝色' },
  { color: '#2F54EB', label: '深蓝色' },
  { color: '#722ED1', label: '紫罗兰' },
  { color: '#EB2F96', label: '玫红色' },
  { color: '#F5222D', label: '红色' },
  { color: '#FA541C', label: '橙红色' },
  { color: '#FA8C16', label: '橙色' },
  { color: '#D4B106', label: '金黄色' },
  { color: '#52C41A', label: '绿色' },
  { color: '#13C2C2', label: '青色' }
]

export const CUSTOMER_TAG_PRESET_COLORS = CUSTOMER_TAG_COLOR_PRESETS.map(({ color }) => color)

export const CUSTOMER_TAG_PRESETS = [{ colors: CUSTOMER_TAG_PRESET_COLORS, label: '预设颜色' }]
